<div class="m-4">
  <h6 class="title text-center">{{ "Pricing" | translate }}</h6>
  <p class="text-center">
    {{
      "Select your package based on your need and we will grow your skills"
        | translate
    }}
  </p>

  <div class="row mx-sm-3">
    <div class="col-12 col-sm-6 col-lg-4 py-2" *ngFor="let item of pricingList">
      <div class="price-card" [ngClass]="{ pro: item.name === 'Pro' }">
        <div class="d-flex">
          <h6 class="name">{{ item.name | translate }}</h6>
          <p class="popular" *ngIf="item.name === 'Pro'">
            {{ "popular" | translate }}
          </p>
        </div>
        <div class="d-flex align-items-center gap-2">
          <span class="title" *ngIf="item.sessions"
            >{{ item.price }}{{ "EGP" | translate }}</span
          >
          <span class="mt-2" *ngIf="item.sessions"
            >/{{ item.sessions }} {{ "Sesions" | translate }}</span
          >
          <span class="title" *ngIf="!item.sessions">{{
            item.price | translate
          }}</span>
        </div>

        <p>
          {{ item.title | translate }}
        </p>
        <hr />
        <div class="d-flex my-2">
          <i class="bi bi-check-circle fs-5 text-success"></i>
          <p class="px-2 m-0">{{ item.includes | translate }}</p>
        </div>
        <div class="text-center mt-auto">
          <a href="https://wa.me/+201555842727" target="_blank">
            <button
              class=""
              [ngClass]="{
                'gradient-button': item.name === 'Pro',
                'border-button': item.name !== 'Pro'
              }"
            >
              {{ "Contact" | translate }}
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
